import { env } from '@/config/env';

/**
 * PR-lane routing — parity with zip-directory. When `VITE_PR_LANE_ENABLED` is on, requests
 * carry an `ocp-pr-lane` header so the backend (Prism → moria/rivendell) routes them to an
 * ephemeral per-PR environment instead of the shared one. The lane id comes from the
 * `ocp-pr-lane` cookie or the `?ocp-pr-lane` query param.
 */
const PR_LANE_HEADER = 'ocp-pr-lane';

function resolvePrLane(): string | null {
  if (!env.prLaneEnabled) {
    return null;
  }
  const cookieMatch = document.cookie.match(/(?:^|;\s*)ocp-pr-lane=([^;]+)/);
  const lane =
    cookieMatch?.[1] ?? new URLSearchParams(window.location.search).get(PR_LANE_HEADER);
  return lane || null;
}

/**
 * Captured once at module load: the route-seeding navigation strips the query string shortly
 * after boot (see app/router.tsx), so reading the lane later would miss a query-provided one.
 * This module is imported transitively before that navigation runs, so the query is still present.
 */
export const prLane: string | null = resolvePrLane();

/** Header that routes a request to the active PR lane (empty object when not on a lane). */
export function prLaneHeaders(): Record<string, string> {
  return prLane ? { [PR_LANE_HEADER]: prLane } : {};
}

/** Debug aid: log any `ocp-pr-lane` response headers so the routed lane can be confirmed. */
export function logPrLaneResponseHeaders(response: Response): void {
  if (!env.prLaneEnabled || !prLane) {
    return;
  }
  response.headers.forEach((value, key) => {
    if (key.startsWith(PR_LANE_HEADER)) {
      console.log(`[PR Lane] Response ${key}: ${value}`);
    }
  });
}
